import type { ValueFormatterParams } from 'ag-grid-community';

import { zeroDecimalFormatter } from '../tableCustomCellRender';
import type { SourceColumn } from '../useDashboardColumns';

import { labels } from 'locales/en.label';
import { ColumnSources, DEFAULT_COL_WIDTH } from './types';

export const pickupColsData: SourceColumn[] = [
	{
		headerName: '1D P/U',
		field: 'pkp_day_1',
		headerTooltip: labels.rec_review.dashboard.tooltip.pkp_day_1,
		maxWidth: DEFAULT_COL_WIDTH,
		valueFormatter: (params: ValueFormatterParams) => {
			return zeroDecimalFormatter(params?.value);
		},
		source: ColumnSources.PICKUP,
	},
	{
		headerName: '3D P/U',
		field: 'pkp_day_3',
		headerTooltip: labels.rec_review.dashboard.tooltip.pkp_day_3,
		maxWidth: DEFAULT_COL_WIDTH,
		valueFormatter: (params: ValueFormatterParams) => {
			return zeroDecimalFormatter(params?.value);
		},
		source: ColumnSources.PICKUP,
	},
	{
		headerName: '7D P/U',
		field: 'pkp_day_7',
		headerTooltip: labels.rec_review.dashboard.tooltip.pkp_day_7,
		maxWidth: DEFAULT_COL_WIDTH,
		valueFormatter: (params: ValueFormatterParams) => {
			return zeroDecimalFormatter(params?.value);
		},
		source: ColumnSources.PICKUP,
	},
	{
		headerName: '1D P/U\nLY',
		field: 'pkp_day_1_ly',
		headerTooltip: labels.rec_review.dashboard.tooltip.pkp_day_1_ly,
		maxWidth: DEFAULT_COL_WIDTH,
		valueFormatter: (params: ValueFormatterParams) => {
			return zeroDecimalFormatter(params?.value);
		},
		source: ColumnSources.PICKUP,
	},
	{
		headerName: '3D P/U\nLY',
		field: 'pkp_day_3_ly',
		headerTooltip: labels.rec_review.dashboard.tooltip.pkp_day_3_ly,
		valueFormatter: (params: ValueFormatterParams) => {
			return zeroDecimalFormatter(params?.value);
		},
		source: ColumnSources.PICKUP,
	},
	{
		headerName: '7D P/U\nLY',
		field: 'pkp_day_7_ly',
		headerTooltip: labels.rec_review.dashboard.tooltip.pkp_day_7_ly,
		maxWidth: DEFAULT_COL_WIDTH,
		valueFormatter: (params: ValueFormatterParams) => {
			return zeroDecimalFormatter(params?.value);
		},
		source: ColumnSources.PICKUP,
	},
	{
		headerName: 'P/U DOA\nLY',
		field: 'pkp_doa_ly',
		headerTooltip: labels.rec_review.dashboard.tooltip.pkp_doa_ly,
		maxWidth: DEFAULT_COL_WIDTH,
		valueFormatter: (params: ValueFormatterParams) => {
			return zeroDecimalFormatter(params?.value);
		},
		source: ColumnSources.PICKUP,
	},
	{
		headerName: '1D P/U (Tr)',
		field: 'transient_pkp_day_1',
		headerTooltip: labels.rec_review.dashboard.tooltip.transient_pickup_day_1,
		maxWidth: DEFAULT_COL_WIDTH,
		valueFormatter: (params: ValueFormatterParams) => {
			return zeroDecimalFormatter(params?.value);
		},
		source: ColumnSources.PICKUP,
	},
	{
		headerName: '3D P/U (Tr)',
		field: 'transient_pkp_day_3',
		headerTooltip: labels.rec_review.dashboard.tooltip.transient_pickup_day_3,
		maxWidth: DEFAULT_COL_WIDTH,
		valueFormatter: (params: ValueFormatterParams) => {
			return zeroDecimalFormatter(params?.value);
		},
		source: ColumnSources.PICKUP,
	},
	{
		headerName: '7D P/U (Tr)',
		field: 'transient_pkp_day_7',
		headerTooltip: labels.rec_review.dashboard.tooltip.transient_pickup_day_7,
		maxWidth: DEFAULT_COL_WIDTH,
		valueFormatter: (params: ValueFormatterParams) => {
			return zeroDecimalFormatter(params?.value);
		},
		source: ColumnSources.PICKUP,
	},
	{
		headerName: '1D P/U (Gr)',
		field: 'group_pkp_day_1',
		headerTooltip: labels.rec_review.dashboard.tooltip.group_pickup_day_1,
		maxWidth: DEFAULT_COL_WIDTH,
		valueFormatter: (params: ValueFormatterParams) => {
			return zeroDecimalFormatter(params?.value);
		},
		source: ColumnSources.PICKUP,
	},
	{
		headerName: '3D P/U (Gr)',
		field: 'group_pkp_day_3',
		headerTooltip: labels.rec_review.dashboard.tooltip.group_pickup_day_3,
		maxWidth: DEFAULT_COL_WIDTH,
		valueFormatter: (params: ValueFormatterParams) => {
			return zeroDecimalFormatter(params?.value);
		},
		source: ColumnSources.PICKUP,
	},
	{
		headerName: '7D P/U (Gr)',
		field: 'group_pkp_day_7',
		headerTooltip: labels.rec_review.dashboard.tooltip.group_pickup_day_7,
		maxWidth: DEFAULT_COL_WIDTH,
		valueFormatter: (params: ValueFormatterParams) => {
			return zeroDecimalFormatter(params?.value);
		},
		source: ColumnSources.PICKUP,
	},
];
